import { JsonPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import type { CurrentUser, User } from '@core/account-types';
import {
  AvatarComponent,
  BadgeComponent,
  DropdownItemComponent,
  IconComponent,
  RtTooltip,
  TruncateComponent,
} from '@core/user-interface-legacy';
import { VisibilityAvatarsListComponent } from '@core/visibility-legacy';

import type { MailboxSelectItem } from '../mailbox-select.types';

@Component({
  selector: 'rt-mailbox-select-item',
  styleUrls: ['./mailbox-select-item.component.less'],
  templateUrl: './mailbox-select-item.component.html',
  imports: [
    JsonPipe,
    DropdownItemComponent,
    IconComponent,
    TruncateComponent,
    AvatarComponent,
    VisibilityAvatarsListComponent,
    RtTooltip,
    BadgeComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.disabled]': '!!item.disabled',
  },
})
export class MailboxSelectItemComponent {
  @Input({ required: true }) public item: MailboxSelectItem;
  @Input({ required: true }) public currentUser: CurrentUser;
  @Input({ required: true }) public users: Record<number, User | null>;
  @Input() public highlighted: boolean;
}
